import React from "react";
import "./page-styles/wytchnienie.scss";
import data from "./data/wytchnienieData";
import Header from "../components/header/Header";
import AnimatedLine from "../components/animatedLine/AnimatedLine";
import Form from "../components/form/Form";
import Partners from "../components/partners/Partners";
import Banner from "../assets/banner.jpg";
import FilmAkcja from "../assets/videos/film-akcja.mp4";

function Wytchnienie() {
  // Link do SJS z Pit Stop Wytchnienie (zaktualizowany)
  const sjsLink = "https://sklep.sjs.pl/pit-stop-wytchnienie";

  // Placeholder dla YouTube video - będzie dostarczony później
  const youtubeVideoId = ""; // TODO: Dodać ID filmu YouTube

  const scrollToDonation = (e) => {
    e.preventDefault();
    const donationSection = document.getElementById("donation-section");
    if (donationSection) {
      donationSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <main className="wytchnienie page">
      {/* SEKCJA BANER Z GRAFIKĄ */}
      <img src={Banner} alt="Wytchnienie Baner" />
      <section className="wytchnienie-landing">
        <div className="wytchnienie-landing__heading">
          {data.headerSlogan}
          <div className="wytchnienie-landing__content h4">
            {data.landingText}
          </div>

          {/* PRZYCISKI CTA */}
          <div className="wytchnienie-landing__buttons">
            <button
              className="wytchnienie-btn wytchnienie-btn--primary"
              onClick={scrollToDonation}>
              Wpłacam darowiznę
            </button>
          </div>
        </div>
      </section>

      {/* SEKCJA: CO KONKRETNIE ZROBIMY */}
      <section className="wytchnienie-section wytchnienie-konkretnie">
        <Header
          cName="wytchnienie-section__header"
          h1={data.headerCoKonkretnie}
          content={data.textCoKonkretnie}
        />

        <a
          href={data.centrumLink}
          className="wytchnienie-btn wytchnienie-btn--secondary"
          target="_blank"
          rel="noopener noreferrer">
          Więcej informacji o Centrum
        </a>
      </section>

      {/* SEKCJA: JAK MOŻESZ POMÓC */}
      <section className="wytchnienie-section wytchnienie-pomoc">
        <Header
          cName="wytchnienie-section__header"
          h1={data.headerJakMozeszPomoc}
        />

        <div style={{ display: "grid", gap: "24px" }}>
          <div className="wytchnienie-pomoc__option">
            <button
              className="wytchnienie-btn wytchnienie-btn--primary"
              onClick={scrollToDonation}>
              Wpłacam darowiznę
            </button>
          </div>

          <div className="wytchnienie-pomoc__option">
            <a
              href={sjsLink}
              className="wytchnienie-btn wytchnienie-btn--primary"
              target="_blank"
              rel="noopener noreferrer">
              Wykup przejazd na torze i wspieraj akcję
            </a>
          </div>
        </div>
      </section>

      {/* SEKCJA: NA CZYM POLEGA WYZWANIE */}
      <section className="wytchnienie-section wytchnienie-wyzwanie">
        <div className="wrapper">
          <Header
            cName="wytchnienie-section__header"
            h1={data.headerNaCzymPolega}
            content={data.textNaCzymPolega}
          />
        </div>
      </section>

      {/* SEKCJA: RANKING */}
      <section className="wytchnienie-section wytchnienie-ranking">
        <div className="header-wrapper__h1">
          <AnimatedLine text="Ranking" />
        </div>

        <iframe
          title="sjs"
          style={{ border: "none" }}
          src="https://sjs.pl/wp-content/uploads/2026/07/Ranking-akcji-charytatywnej-05-26-1.html"
          width="100%"
          height="400"></iframe>

        <noscript>
          <a
            href="https://sjs.pl/wp-content/uploads/2026/07/Ranking-akcji-charytatywnej-05-26-1.html"
            target="_blank"
            rel="noopener noreferrer">
            Zobacz ranking
          </a>
        </noscript>
      </section>

      {/* SEKCJA: PARTNERZY I FILM */}
      <section className="wytchnienie-section wytchnienie-partnerzy">
        <div className="wrapper">
          <div className="wytchnienie-partnerzy__content h4">
            {data.textPartnerzy}
          </div>

          {/* Osadzony lokalny film (film-akcja) */}
          <div className="wytchnienie-video" style={{ marginTop: "16px" }}>
            <div className="wytchnienie-video__wrapper">
              <video
                autoPlay
                muted
                controls
                width="100%"
                className="wytchnienie-video__player">
                <source src={FilmAkcja} type="video/mp4" />
                Twoja przeglądarka nie wspiera odtwarzania tego wideo.
              </video>
            </div>
          </div>

          {/* FILM O AKCJI */}
          {youtubeVideoId && (
            <div className="wytchnienie-video">
              <div className="wytchnienie-video__wrapper">
                <iframe
                  src={`https://www.youtube.com/embed/${youtubeVideoId}`}
                  title="Film o Akcji Pit Stop Wytchnienie"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen></iframe>
              </div>
            </div>
          )}
        </div>
      </section>

      {/* SEKCJA: FINALE */}
      <section className="wytchnienie-section wytchnienie-finale">
        <div className="wrapper">
          <div className="wytchnienie-finale__content h3">
            {data.textFinale}
          </div>
        </div>
      </section>

      {/* SEKCJA: BRAMKA PŁATNOŚCI */}
      <section
        id="donation-section"
        className="wytchnienie-section wytchnienie-donation">
        <div className="wrapper">
          <div className="header-wrapper__h1 wrapper">
            <AnimatedLine text="Wpłać darowiznę" />
          </div>
        </div>
        <Form />
      </section>

      {/* SEKCJA: DANE DO WPŁAT TRADYCYJNYCH */}
      <section className="wytchnienie-section wytchnienie-traditional">
        <div className="wrapper">
          <div className="header-wrapper__h1 wrapper">
            <AnimatedLine text="Przelew tradycyjny" />
          </div>
          <div className="data-container">
            <p className="h3 bold wide">Dane do przelewu tradycyjnego:</p>
            <p className="h4 medium">Numer konta:</p>
            <p className="h4 right">80 1240 4588 1111 0011 0099 1078</p>

            <p className="h4 medium">Tytuł przelewu:</p>
            <p className="h4 right">Darowizna - Pit Stop Wytchnienie</p>
            <p className="h4 medium">Nasze dane:</p>
            <p className="h4 right">
              FUNDACJA „MLEKO I MIÓD" <br /> os. Centrum C 3 / 18 <br /> 31-929
              Kraków
            </p>
          </div>
        </div>
      </section>

      {/* SEKCJA: ORGANIZATORZY I PARTNERZY */}
      <section className="wytchnienie-section wytchnienie-organizatorzy">
        <div className="wrapper">
          <div className="wytchnienie-organizatorzy__content h4">
            <p>{data.organizatorzy}</p>
            <p>{data.partnerzy}</p>
            <p>
              <strong>{data.ambasador}</strong>
            </p>
          </div>
        </div>
      </section>

      <Partners />
    </main>
  );
}

export default Wytchnienie;
